<div class="backdrop" (click)="closeDialog.emit()"></div>
<div class="dialog-wrapper">
  <div class="dialog">
    <div class="box">
      <div class="title">הערה</div>
      <textarea rows="4" [value]="content"></textarea>
      <div (click)="closeDialog.emit()" class="button">סגור חלון</div>
    </div>
  </div>
</div>